// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'

import ShiftAgencyList from 'syft-acp-core/entities2/ShiftAgencyList'
import PageView from 'syft-acp-core/components/PageView'
import CascadeFullJobModal from 'syft-acp-core/components/Modal/CascadeFullJobModal'
import AgencyCallModal from 'syft-acp-core/components/Modal/AgencyCallModal'

const modalName = 'cascadeFullModal'
const agencyCallModalName = 'agencyCallModal'

export const AgencyShifts = () => (
  <PageView title={['Agency shifts', 'Shifts']} entityPage>
    <ShiftAgencyList />
    <CascadeFullJobModal name={modalName} />
    <AgencyCallModal name={agencyCallModalName} />
  </PageView>
)
